(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
var czI18n = __pewniaki_inline_cfg[0];
// SVG scales its text with the viewBox; keep axis labels at 13 screen pixels.
var czObservedChart = null;
function czAxisFont(chart) {
    var matrix = chart.getScreenCTM();
    var scale = matrix && Math.hypot(matrix.a, matrix.b);
    if (!scale) return;
    chart.querySelectorAll('text').forEach(function (text) {
        text.style.fontSize = (13 / scale) + 'px';
    });
}
var czResize = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(function () {
    if (czObservedChart) czAxisFont(czObservedChart);
}) : null;
function czObserveChart(chart) {
    if (!chart) return;
    if (czObservedChart !== chart) {
        if (czResize) { czResize.disconnect(); czResize.observe(chart); }
        czObservedChart = chart;
    }
    czAxisFont(chart);
}
// Fala 10: kolejnosc i filtr tabeli (wiersze niosa data-n i data-hits, SSR i render()).
function czUporzadkuj() {
    var tab = document.querySelector('[data-czestotliwosc-tabela]'), body = tab && tab.tBodies[0];
    if (!body) return;
    var s = (document.querySelector('[data-cz-sortuj]') || {}).value || 'numer';
    var fl = (document.querySelector('[data-cz-filtr]') || {}).value || '';
    var rows = Array.prototype.slice.call(body.rows).filter(function (r) { return r.hasAttribute('data-n'); });
    var nr = function (r) { return Number(r.getAttribute('data-n')); }, tr = function (r) { return Number(r.getAttribute('data-hits')) || 0; };
    rows.sort(function (a, b) {
        if (s === 'malejaco') return (tr(b) - tr(a)) || (nr(a) - nr(b));
        if (s === 'rosnaco') return (tr(a) - tr(b)) || (nr(a) - nr(b));
        return nr(a) - nr(b);
    });
    var widac = 0, zmiana = rows.some(function (r, i) { return body.rows[i] !== r; });
    rows.forEach(function (r) {
        var n = nr(r), ok = true;
        if (fl === 'parzyste') ok = n % 2 === 0;
        else if (fl === 'nieparzyste') ok = n % 2 === 1;
        else if (fl.charAt(0) === 'd') { var d = Number(fl.slice(1)); ok = n > d * 10 && n <= d * 10 + 10; }
        r.hidden = !ok; if (ok) widac++;
        if (zmiana) body.appendChild(r);
    });
    var st = document.querySelector('[data-cz-widok-stan]');
    if (st) st.textContent = czTekst('cz.filter.shown', { x: widac, y: rows.length });
    var chart=document.querySelector('[data-cz-svg]');
    requestAnimationFrame(function () { czObserveChart(chart); });
    if(chart){
        // Same ordering/filter as the table; counts and the benchmark stay intact.
        var bars=Array.from(chart.querySelectorAll('[data-cz-bar]')),byNumber=new Map(bars.map(function(b){return[Number(b.dataset.czBar),b];}));
        chart.querySelectorAll('[data-cz-order-label]').forEach(function(e){e.remove();});
        chart.querySelectorAll('text[aria-hidden="true"]').forEach(function(e){e.remove();});
        var countN=Number((document.querySelector('[data-cz-svg-n]')||{}).textContent),pos=0;
        rows.forEach(function(r){var bar=byNumber.get(nr(r));if(!bar)return;
            bar.setAttribute('display',r.hidden?'none':'inline');if(r.hidden)return;
            var x=42+pos*10+1.5,rect=bar.querySelector('rect');rect.setAttribute('x',x);chart.appendChild(bar);
            var h=Number(bar.dataset.count),ties=bars.filter(function(b){return Number(b.dataset.count)===h;}).length;
            var label=nr(r)+': '+h+' / '+countN+'; '+(countN?(h*100/countN).toFixed(1).replace('.',/^en(?:-|$)/i.test(document.documentElement.lang||'')?'.':',')+'%':'—')+'; '+(/^en(?:-|$)/i.test(document.documentElement.lang||'')?'ties ':'remisy ')+ties;
            bar.setAttribute('aria-label',label);bar.querySelector('title').textContent=label;
            if(pos===0||pos%5===0){var tick=document.createElementNS('http://www.w3.org/2000/svg','text');[['x',x+3.5],['y',180],['text-anchor','middle'],['font-size',8],['fill','currentColor'],['data-cz-order-label','']].forEach(function(a){tick.setAttribute(a[0],a[1]);});tick.textContent=nr(r);chart.appendChild(tick);}
            pos++;
        });
    }
}
['[data-cz-sortuj]', '[data-cz-filtr]'].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) el.addEventListener('change', czUporzadkuj);
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', czUporzadkuj); else czUporzadkuj();
function czTekst(key, params) {
    return czI18n[key].replace(/\$\{([A-Za-z_][A-Za-z0-9_]*)\}/g, function (_, name) { return String(params[name]); });
}

window.PEWNIAKI_ANALIZA = {
    plik: '/assets/json/db/' + __pewniaki_inline_cfg[1] + '/analizy/czestotliwosc.json',
    wersja: __pewniaki_inline_cfg[2],
    lata: '/assets/json/db/' + __pewniaki_inline_cfg[3] + '/lata/',
    sumujLata: function (roczniki) {
        var N=0, hits={};
        roczniki.forEach(function(r){N+=r.losowan||0;Object.keys(r.main||{}).forEach(function(n){hits[n]=(hits[n]||0)+r.main[n];});});
        var liczby={};Object.keys(hits).forEach(function(n){liczby[n]={hits:hits[n]};});
        return {losowan:N,liczby:liczby};
    },
    wnioski: function (o,key,d) {
        if(!o || o.powod || !o.losowan) return [czI18n['cz.empty.conclusion']];
        if(!d || !Number.isInteger(d.pula) || d.pula < 1 || !Number.isInteger(d.typuje) || d.typuje < 1 || d.typuje > d.pula) return [czI18n['cz.inconsistent']];
        return [czTekst('cz.range',{n:o.losowan,e:(o.losowan*d.typuje/d.pula).toFixed(2).replace('.',(/^en(?:-|$)/i.test(document.documentElement.lang||'')?'.':','))}),
            czI18n['cz.independence']];
    },
    render: function (o,key,d) {
        var section=document.querySelector('[data-czestotliwosc]');
        if(!section)return;
        var en=/^en(?:-|$)/i.test(document.documentElement.lang||'');
        var wyk=section.querySelector('[data-cz-wykres]');
        if(!wyk){wyk=document.createElement('div');wyk.setAttribute('data-cz-wykres','');section.insertBefore(wyk,section.querySelector('[data-cz-uwaga]'));}
        wyk.replaceChildren();wyk.hidden=false;section.hidden=false;
        var uwaga=section.querySelector('[data-cz-uwaga]');uwaga.hidden=true;
        section.querySelectorAll('.komunikat--brak').forEach(function(p){p.hidden=true;});
        var N=o&&o.losowan,counts=[],valid=!!(o&&!o.powod&&d&&Number.isInteger(N)&&N>=0&&Number.isInteger(d.pula)&&d.pula>0&&d.pula<=100&&Number.isInteger(d.typuje)&&d.typuje>0&&d.typuje<=d.pula&&o.liczby&&typeof o.liczby==='object');
        if(valid){for(var j=1;j<=d.pula;j++){var record=o.liczby[j],h=record==null?0:record.hits;counts.push(h);if(!Number.isInteger(h)||h<0||h>N)valid=false;}}
        if(valid&&counts.reduce(function(a,b){return a+b;},0)!==N*d.typuje)valid=false;
        if(!valid){
            uwaga.textContent=czI18n['cz.inconsistent'];uwaga.hidden=false;
            section.querySelector('[data-czestotliwosc-tabela] tbody').replaceChildren();
            section.querySelector('[data-czestotliwosc-n]').textContent='—';section.querySelector('[data-czestotliwosc-e]').textContent='—';return;
        }
        var E=N*d.typuje/d.pula;
        if(!N){wyk.textContent=czI18n['cz.empty.chart'];}
        else{
            var ns='http://www.w3.org/2000/svg',width=42+d.pula*10+12,max=Math.max.apply(null,counts),scale=max?150/max:0;
            function svg(tag,attrs,text){var e=document.createElementNS(ns,tag);Object.keys(attrs).forEach(function(k){e.setAttribute(k,String(attrs[k]));});if(text!=null)e.textContent=text;return e;}
            var caption=document.createElement('p');caption.textContent=czI18n['cz.draws'];
            var counter=document.createElement('span');counter.setAttribute('data-cz-svg-n','');counter.textContent=N;caption.appendChild(counter);wyk.appendChild(caption);
            var scroll=document.createElement('div');scroll.className='tabela-scroll';scroll.setAttribute('role','region');scroll.tabIndex=0;scroll.setAttribute('aria-label',czI18n['cz.region']);wyk.appendChild(scroll);
            var chart=svg('svg',{'data-cz-svg':'',viewBox:'0 0 '+width+' 200',role:'img','aria-label':czTekst('cz.chart.dynamic',{n:N})});chart.classList.add('wykres-czestotliwosc','wykres-czestotliwosc--dynamic');chart.style.minWidth=Math.max(width,320)+'px';scroll.appendChild(chart);
            chart.appendChild(svg('desc',{},__pewniaki_inline_cfg[4]));
            chart.appendChild(svg('line',{x1:42,y1:162,x2:width-12,y2:162,stroke:'currentColor'}));
            chart.appendChild(svg('text',{x:2,y:162,fill:'currentColor'},'0'));
            chart.appendChild(svg('text',{x:2,y:16,fill:'currentColor'},max));
            chart.appendChild(svg('line',{'data-cz-expected':E,x1:42,x2:width-12,y1:162-E*scale,y2:162-E*scale,stroke:'currentColor','stroke-dasharray':'4 3'}));
            var expectedTitle=svg('title',{},czTekst('cz.expected.dynamic',{e:E}));chart.querySelector('[data-cz-expected]').appendChild(expectedTitle);
            counts.forEach(function(h,i){var n=i+1,label=czTekst('t_7438b05803388645',{v28:n,v29:h,v30:N}),g=svg('g',{'data-cz-bar':n,'data-count':h,tabindex:0,'aria-label':label});
                g.appendChild(svg('title',{},label));g.appendChild(svg('rect',{x:42+i*10+1.5,y:162-h*scale,width:7,height:h*scale,fill:'currentColor'}));chart.appendChild(g);
                if(d.pula<=20||n===1||n%5===0)chart.appendChild(svg('text',{x:47+i*10,y:180,'text-anchor':'middle','font-size':8,fill:'currentColor','data-cz-order-label':''},n));
            });
            var legend=document.createElement('p');legend.className='tekst-maly';legend.setAttribute('data-cz-legend','');legend.textContent=__pewniaki_inline_cfg[5];wyk.appendChild(legend);
        }
        var f=function(v){return v.toFixed(2).replace('.',en?'.':',');};
        document.querySelector('[data-czestotliwosc-n]').textContent=N;
        document.querySelector('[data-czestotliwosc-e]').textContent=f(E);
        var body=document.querySelector('[data-czestotliwosc-tabela] tbody'); body.replaceChildren();
        for(var n=1;n<=d.pula;n++) {
            var h=Number((o.liczby[n]||{}).hits)||0,tr=document.createElement('tr');tr.setAttribute('data-n',n);tr.setAttribute('data-hits',h);
            var numberCell=document.createElement('td');numberCell.className='liczbowa';
            var ball=document.querySelector('[data-cz-kula]').content.cloneNode(true);
            ball.querySelector('.kula').textContent=n;numberCell.appendChild(ball);tr.appendChild(numberCell);
            [h,N?(h*100/N).toFixed(1).replace('.',en?'.':','):'—',f(E),f(h-E)].forEach(function(v){var td=document.createElement('td');td.className='liczbowa';td.textContent=v;tr.appendChild(td);});
            body.appendChild(tr);
        }
        czUporzadkuj();
    }
};
})();
